import React from 'react';
import { observer } from 'mobx-react';
import { AppUI } from '@seedlang/state';
import { Theme } from '@seedlang/constants';
import Alert from 'components/alert';

export const getMobileDeviceText = userSubscriptions => {
  const activeMobileSubscription = userSubscriptions?.find(item =>
    item.isActive &&
    ['ios', 'android'].includes(item.paymentMethod)
  );

  if (activeMobileSubscription?.paymentMethod === 'ios') return 'iOS';
  if (activeMobileSubscription?.paymentMethod === 'android') return 'Android';
  return null;
};

@observer
class MobileSubscriptionBanner extends React.Component {
  get mobileDeviceText() {
    if (AppUI.user?.signedOut) return null;
    return getMobileDeviceText(this.props.userSubscriptions || AppUI.userSubscriptionStore.indexData);
  }

  render() {
    if (!this.mobileDeviceText) return null;

    return (
      <Alert
        background={Theme.green}
        margin='20px 0'
        padding='14px 18px'
        textAlign='center'
      >
        You currently have an active subscription on your {this.mobileDeviceText} device. Please continue managing your subscription there.
      </Alert>
    );
  }
}

export default MobileSubscriptionBanner;
